import { PIAPI } from '@core/base';
import { defu } from 'defu';
import { CreateTaskRequest, TaskResponse } from '@core/types';
import { LumaBaseParams, LumaConfig } from './types';

export class LumaAPI extends PIAPI {
    private config: LumaConfig;

    constructor(apiKey: string, config: LumaConfig = {}, baseUrl?: string) {
        super(apiKey, baseUrl);
        this.config = config;
    }

    private static DEFAULT_PARAMS = {
        expand_prompt: true,
        loop: true,
    };

    private createLumaRequest(params: LumaBaseParams): CreateTaskRequest {
        const finalInput = defu(params, LumaAPI.DEFAULT_PARAMS);

        const request: CreateTaskRequest = {
            model: "luma",
            task_type: "video_generation",
            input: finalInput,
        };

        if (this.config.webhookUrl && this.config.webhookSecret) {
            request.config = {
                webhook_config: {
                    endpoint: this.config.webhookUrl,
                    secret: this.config.webhookSecret,
                },
            };
        }

        return request;
    }

    async createVideo(params: LumaBaseParams): Promise<TaskResponse> {
        const request = this.createLumaRequest(params);
        return this.createTask(request);
    }
} 